import { render, staticRenderFns } from "./LeaderBoardItems.vue?vue&type=template&id=3e61b5c4&scoped=true"
import script from "./LeaderBoardItems.vue?vue&type=script&lang=js"
export * from "./LeaderBoardItems.vue?vue&type=script&lang=js"
import style0 from "./LeaderBoardItems.vue?vue&type=style&index=0&id=3e61b5c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e61b5c4",
  null
  
)

export default component.exports